import React from 'react';
import {Box} from "@mui/material";
import {DoorOpenOutlined} from "@mui-symbols-material/w200";
import {IconButton} from "@mui/joy";
import {DeleteFilledRounded} from "@mui-symbols-material/w300";
import {DeleteGridItem} from "../../../graphql/mutations/deleteGridItem";
import {useMutation} from "@apollo/client";
import {toast} from "react-toastify";
import {resolveErrorMessage} from "../../../utils/resolveErrorMessage";
import {useTranslation} from "react-i18next";

interface Props {
    gridItemId?: string;
    isEditMode: boolean
}

const GridDoor = ({gridItemId, isEditMode}: Props) => {
    const {t } = useTranslation();
    const [deleteGridItemMutation] = useMutation(DeleteGridItem)

    const handleDeleteDoor = () => {
        deleteGridItemMutation({
            variables: {
                id: gridItemId,
            },
            refetchQueries: ["GridDetail"]
        })
            .then((res) => {
                if (res.data?.deleteGridItem?.success && res.data?.deleteGridItem?.message) {
                    toast.success(res.data.deleteGridItem.message);
                } else {
                    toast.error(t("Error deleting door."))
                }
            })
            .catch((err) => {
                toast.error(resolveErrorMessage(err, t))
            })
    }

    return (
        <Box
            border={isEditMode ? "1px solid #ccc" : "none"}
            borderRadius={"3px"}
            bgcolor={isEditMode ? "#E5E5E5" : "transparent"}
            position="relative"
            height="100%"
            display="flex"
            flexDirection="row"
            alignItems="center"
            justifyContent="center"
            p={"5px"}
        >
            <DoorOpenOutlined sx={{fontSize: "84px"}}/>
            {isEditMode && (
                <Box position="absolute" top={4} right={4} display="flex" gap={0.5}>
                    <IconButton
                        className="no-drag"
                        size="sm"
                        variant="soft"
                        color="primary"
                        onClick={handleDeleteDoor}
                    >
                        <DeleteFilledRounded />
                    </IconButton>
                </Box>
            )}
        </Box>
    );
}

export default GridDoor;
